export enum ViewColoring {
  DEFAULT = 'view-default',
  CONTRAST = 'view-contrast',
}

export enum ViewIndicators {
  COLOR = 'view-color',
  ICONS = 'view-icons',
  COLOR_AND_ICONS = 'view-color-and-icons',
  COLOR_AND_CONTRAST_ICONS = 'view-color-and-contrast-icons',
}